import { DtNumber } from '@ow/ditto-core'

const { config } = DtNumber
export { default as Render } from './render'
export { config }
